import {
  AvailableDeliverySlotDto,
  DeliveryAddressDto,
  OrderDto,
  PriceDto
} from '@eurogast/hub-client-typescript';
import { Step } from '@/cart-page/header/Step';
import { Cart } from '@/services/cart/model/cart';

export interface RootState {
  cart: CartState;
  commonOrderDetail: CommonOrderDetailState;
  defaultOrderDetail: DefaultOrderDetailState;
  fairOrderDetail: FairOrderDetailState;
  message: MessageState;
  labelSelection: LabelSelectionState;
}

export interface CartState {
  cart?: Cart;
  step: Step;
  lastSuccessfulOrder?: OrderDto;
}

export interface CommonOrderDetailState {
  customerOrderId?: string;
  deliveryAddress?: DeliveryAddressDto;
  unloadingArea?: string;
  notes?: string;
}

export interface DefaultOrderDetailState {
  deliverySlot: AvailableDeliverySlotDto;
}

export interface FairOrderDetailState {
  requestedDeliveryDay: Date;
  requestedDeliveryDayFreshProducts: Date;
}

export interface MessageState {
  title: string;
  message: string;
  connectionIssue: boolean;
}

export interface DetailState {
  price: PriceDto;
}

export interface LabelSelectionState {
  labelSelectionSkuMap: Array<{ sku: string; amount: number }>;
}

export interface NotificationsState {
  unreadCount: number;
}

export interface WindowWidthState {
  windowWidth: number;
}

export const CART = 'cart';
export const COMMON_ORDER_DETAIL = 'commonOrderDetail';
export const DEFAULT_ORDER_DETAIL = 'defaultOrderDetail';
export const FAIR_ORDER_DETAIL = 'fairOrderDetail';
export const MESSAGE = 'message';
export const DETAIL = 'detail';
export const LABEL_SELECTION = 'labelSelection';
export const NOTIFICATIONS = 'notifications';
export const WINDOW_WIDTH = 'windowWidth';

function prefix(namespace: string, sub: string): string {
  return `${namespace}/${sub}`;
}

export const Actions = {
  Notifications: {
    fetchUnreadCount: prefix(NOTIFICATIONS, 'fetchUnreadCount'),
  },
};

export const Mutations = {
  Cart: {
    setLocalCart: prefix(CART, 'setLocalCart'),
    setItemPartial: prefix(CART, 'setItemPartial'),
    nextStep: prefix(CART, 'nextStep'),
    resetCheckoutState: prefix(CART, 'resetCheckoutState'),
    addToLocalCart: prefix(CART, 'addToLocalCart'),
    setLastSuccessfulOrder: prefix(CART, 'setLastSuccessfulOrder')
  },
  CommonOrderDetail: {
    setDeliveryAddress: prefix(COMMON_ORDER_DETAIL, 'setDeliveryAddress'),
    setUnloadingArea: prefix(COMMON_ORDER_DETAIL, 'setUnloadingArea'),
    setNotes: prefix(COMMON_ORDER_DETAIL, 'setNotes'),
    setCustomerOrderId: prefix(COMMON_ORDER_DETAIL, 'setCustomerOrderId'),
    resetCheckoutState: prefix(COMMON_ORDER_DETAIL, 'resetCheckoutState'),
  },
  DefaultOrderDetail: {
    setDeliverySlot: prefix(DEFAULT_ORDER_DETAIL, 'setDeliverySlot'),
    resetCheckoutState: prefix(DEFAULT_ORDER_DETAIL, 'resetCheckoutState'),
  },
  FairOrderDetail: {
    setRequestedDeliveryDay: prefix(FAIR_ORDER_DETAIL, 'setRequestedDeliveryDay'),
    setRequestedDeliveryDayFreshProducts: prefix(FAIR_ORDER_DETAIL, 'setRequestedDeliveryDayFreshProducts'),
    resetCheckoutState: prefix(FAIR_ORDER_DETAIL, 'resetCheckoutState')
  },
  Message: {
    resetMessage: prefix(MESSAGE, 'resetMessage'),
    pushMessage: prefix(MESSAGE, 'pushMessage')
  },
  Detail: {
    setPrice: prefix(DETAIL, 'setPrice')
  },
  LabelSelection: {
    addSku: prefix(LABEL_SELECTION, 'addSku'),
    setSkuList: prefix(LABEL_SELECTION, 'setSkuList'),
    removeSku: prefix(LABEL_SELECTION, 'removeSku'),
    clearSkus: prefix(LABEL_SELECTION, 'clearSkus'),
    setAmount: prefix(LABEL_SELECTION, 'setAmount'),
    restoreLabelPrint: prefix(LABEL_SELECTION, 'restoreLabelPrint')
  },
  WindowWidth: {
    setWindowWidth: prefix(WINDOW_WIDTH, 'setWindowWidth')
  }
};

export const Getters = {
  Cart: {
    getItemBySku: prefix(CART, 'getItemBySku'),
    getAllItems: prefix(CART, 'getAllItems'),
    getTotalPrice: prefix(CART, 'getTotalPrice')
  },
  Detail: {
    getPrice: prefix(DETAIL, 'getPrice')
  },
  LabelSelection: {
    getCount: prefix(LABEL_SELECTION, 'getCount'),
    getSkus: prefix(LABEL_SELECTION, 'getSkus')
  },
  Notifications: {
    getUnreadCount: prefix(NOTIFICATIONS, 'getUnreadCount'),
  },
  WindowWidth: {
    getWindowWidth: prefix(WINDOW_WIDTH, 'getWindowWidth')
  }
};
